import axios from 'axios'
import { UnderlyingCollateralCTO } from '@shared/UnderlyingCollateralCTO'
import { User } from 'oidc-client-ts'

export const fetchCollateral = async (
  serverApiBaseUrl: string,
  restAPIKey: string,
  poolAddr: string
): Promise<UnderlyingCollateralCTO[]> => {
  const r = await axios.get(`${serverApiBaseUrl}/collateral/${poolAddr}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': restAPIKey,
    },
  })
  // Adjust if your API response structure is different
  return r.data.collateral || []
}

export const saveCollateral = async (
  serverApiBaseUrl: string,
  poolAddr: string,
  collateralArray: UnderlyingCollateralCTO[],
  restAPIKey: string,
  cognitoUser?: User
): Promise<void> => {
  const accessToken = cognitoUser?.access_token
  await axios.put(
    `${serverApiBaseUrl}/collateral`,
    { poolAddr, collateral: collateralArray },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
        'x-api-key': restAPIKey, // include if still needed
      },
    }
  )
}
